module.exports = __webpack_public_path__ + "static/media/records-accent.d95d87af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/records-accent.svg
// module id = 690
// module chunks = 0